import { ThemeColorPresetsValue } from 'src/components/settings';
import { getPresets } from 'src/components/settings/presets';
import palette from './palette';
import { createTheme } from '@mui/material';
import typography from './typography';
import shadows from './shadows';
import customShadows from './customShadows';
import ComponentsOverrides from './overrides';

export function createCustomTheme(
  selectedPresetKey: ThemeColorPresetsValue,
  themeMode: 'light' | 'dark' = 'light'
) {
  const selectedPreset = getPresets(selectedPresetKey);
  const themePalette = palette(themeMode);

  // Create the custom theme, but force primary to be from defaultPreset
  const theme = createTheme({
    palette: {
      ...themePalette,
      primary: selectedPreset,
    },
    typography,
    shape: { borderRadius: 8 },
    shadows: shadows(themeMode),
    customShadows: customShadows(themeMode),
  });

  theme.components = ComponentsOverrides(theme);

  return theme;
}
